import MonixModal from "@/commons/widget/monix-modal";
import { Spin } from "antd";
import { useEffect, useState } from "react";
import { ReactComponent as CheckSvg } from '@/commons/icons/table/check.svg';
import { ReactComponent as CheckedSvg } from '@/commons/icons/table/checked.svg';
import { GlobalCable } from "@/commons/interface/lib-device/global-cable";
import { getGlobalCables } from "@/api/maint/lib/lib-cable";

interface IProps {
    visible: boolean
    setVisible: (value: boolean) => void
    onFinish: (values: number[]) => void
    loading: boolean
    filterItems: GlobalCable[]
}

export default function LinkGlobalCableModal(props: IProps) {
    const [globalCables, setGlobalCables] = useState<GlobalCable[]>([]); // 可选中的线缆
    const [selected, setSelected] = useState<number[]>([]); // 选中的线缆id

    // 初始化
    useEffect(() => {
        generateData();
    }, [])

    // 按下确认按钮
    const onSaveClick = () => {
        if (selected?.length === 0) {
            props.setVisible(false);
            return;
        }
        if (props?.onFinish) {
            props.onFinish(selected);
        }
    }

    // 获取可选择数据
    const generateData = () => {
        getGlobalCables().then(res => {
            let data: GlobalCable[] = res.data || [];
            if (props?.filterItems) {
                data = data?.filter(item => !props?.filterItems?.some(i => i.id === item.id)) || [];
            }
            setGlobalCables(data);
        })
    }

    return (
        <MonixModal
            title={"添加数据线缆"}
            visible={props.visible}
            setVisible={(e) => props.setVisible(e)}
            onSaveClick={onSaveClick}
            wrapClassName="link-global-device-modal"
            saveDisable={props.loading}
        >
            <Spin wrapperClassName="link-global-device-body" spinning={props.loading}>
                <div className="link-body">
                    {globalCables?.length !== 0 && globalCables?.map((item, key) => (
                        <div className="link-item" key={key}>
                            <div className="item-icon" onClick={() => {
                                let idx = selected?.findIndex(g => g === item.id);
                                setSelected(prev => {
                                    if (idx === -1) {
                                        prev.push(item.id);
                                    } else {
                                        prev.splice(idx, 1);
                                    }
                                    return [...prev];
                                })
                            }}>
                                {!selected?.some(g => g === item.id) && <CheckSvg />}
                                {selected?.some(g => g === item.id) && <CheckedSvg />}
                            </div>
                            <div className="item-text">{`名称：${item?.name || ''}`}</div>
                            <div className="item-text">{`型号：${item?.marking || ''}`}</div>
                        </div>
                    ))}
                    {globalCables?.length === 0 && <div className="link-item">
                        <div className="item-text">{`暂无数据`}</div>
                    </div>
                    }
                </div>
            </Spin>
        </MonixModal>
    )
}